// extracted by mini-css-extract-plugin
export default {"attachment":"HomeAttachmentsTabContent_attachment__0t-Pw"};